import * as React from "react";
import { connect } from "react-redux";
import configureStore from "../store/configureStore";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Switch, withRouter } from "react-router-dom";
import rootReducer from "../reducers";
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

import * as Tools from "../helpers/Tools";
import * as types from "../constants/actionTypes";
import configureFetch from "../helpers/configureFetch";

//import 'bootstrap/dist/css/bootstrap.min.css';
// import scss to cause webpack to see it as a dependency...
import "../../scss/include/index.scss";
import Popper from 'popper.js';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import { logReactError } from "../api/loggingApi";

import Cookies from "cookies-js";

import RefreshOnNav from "./common/RefreshOnNav";

import { ApplicationInsights } from "@microsoft/applicationinsights-web";


import AppRoutes from "./AppRoutes";

import MainErrorBoundary from "./common/MainErrorBoundary";
import { logUI } from "../api/andyliticsApi";
import { authContext } from "../adalConfig";

import { HistoryBinder } from "./common/HistoryBinder";



window.store = null;

// Scrub logout message when leaving the page (for any reason, including page refresh)
try {
    window.document.body.onbeforeunload = function (e) {
        try {
            let sCookie = Cookies.get(window.serverData.data.environment + "-root-Domain");
            if (sCookie) {
                let oCookie = JSON.parse(sCookie);
                oCookie.domain.lom = null;
                let sDomain = Tools.getDomain();

                Cookies.set(window.serverData.data.environment + "-root-Domain", JSON.stringify(oCookie), { domain: sDomain, path: "/"});
            }
        }
        catch (E2) {

        }
    };
}
catch (E) {

}

window.persistor = null;
configureFetch();


/**
 * Main app component.
 */
export class App extends React.Component {

    constructor(params) {
        super(params);
        this.serverData = window.serverData.data;
        this.menuItems = this.serverData.activeMenuItems;

        window.store = configureStore(this.serverData);
        window.persistor = persistStore(store);
        window.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: window.serverData.data.instrumentationKey,
                enableDebug: false,
                disableFetchTracking: false,
                disableAjaxTracking: false,
                cookieDomain: Tools.getDomain(),
                enableCorsCorrelation: window.serverData.data.enableCorsCorrelation,
                correlationHeaderExcludedDomains: [
                    'rxapi-tst.bswhive.com',
                    'rx.bswapi.com'
                ],
                autoTrackPageVisitTime: true
            }
        });
        window.ai = appInsights.loadAppInsights();

        let telemetryInitializer = function () {
            appInsights.addTelemetryInitializer(function (envelope) {
                var telemetryItem = envelope.baseData;
                let oState = window.store.getState();
                let oDomain = oState ? oState.domain : null;
                if (oDomain) {
                    let sCorrelationID = oDomain.c || Cookies.get("bsw-CorrelationId");
                    let sSessionID = oDomain.s || Cookies.get("bsw-SessionId");
                    let sUserName = oDomain.un || window.currentUserName;

                    telemetryItem.properties = telemetryItem.properties || {};
                    if (sCorrelationID) {
                        telemetryItem.properties["AL_CorrelationID"] = sCorrelationID;
                    }
                    if (sSessionID) {
                        telemetryItem.properties["AL_SessionID"] = sSessionID;
                    }
                    if (sUserName && sUserName !== "") {
                        appInsights.setAuthenticatedUserContext(sUserName);
                    }
                }
            });
        };

        if (appInsights.queue !== undefined) {
            appInsights.queue.push(telemetryInitializer);
        } else {
            telemetryInitializer();
        }


        this.appUpdate = null;
        
        if (typeof window !== 'undefined') {
            let authToken = Cookies("AuthToken" + this.serverData.environment);
            let oState = window.store.getState();
            if (oState && oState.domain && oState.domain.t) {
                authToken = oState.domain.t;
            }
            // setup server data first
            store.dispatch({ type: types.SET_SERVER_DATA, serverData: window.serverData.data });
            store.dispatch({ type: types.LOAD_TERMS_AND_CONDITIONS });

            if (oState.domain.adt) {
                store.dispatch({ type: types.SET_PHYND_DATA, data: null });  // In case of reload
                store.dispatch({ type: types.SET_AD_ID_TOKEN, idToken: oState.domain.adt, loadRooms: true });
            }
            
            // Set domain data from user
            var oUser = authContext.getCachedUser();
            if (oUser) {
                //debugger;
                store.dispatch({
                    type: types.SET_AD_USER_DATA,
                    user: oUser
                });
            }
            //debugger;

            //store.dispatch({ type: types.VERIFY_LOGIN, token: authToken, DontClearRedirectURL: true, forceRefresh: true });

            store.dispatch({ type: types.GET_APP_UPDATE });

            store.dispatch({ type: types.APP_START });
        }

    }

    //Handle Refresh Scenarios
    componentDidMount() {
        if (typeof window !== 'undefined')
        {
            this.appUpdate = window.setInterval(this.handleAppRefresh, window.serverData.data.appRefreshTimer ? window.serverData.data.appRefreshTimer * 60 * 1000 : 60 * 1000);
        } 
        let oState = window.store.getState();
        let oDomain = oState ? oState.domain : null;
        if (oDomain.t === null && oDomain.adt) {
            // We need to do this in the cases where the token exchange get's cut off by the url update
            //store.dispatch({ type: types.SET_AD_ID_TOKEN, idToken: domain.adt });
        }

        authContext.handleWindowCallback();


    }

    componentWillUnmount() {
        if (typeof window !== 'undefined')
        {
            window.clearInterval(this.appUpdate);
        }

    }

    /**
     * Global error trap; logs error info to the api.
     * 
     * @param {any} errorMsg react error
     * @param {any} errorInfo react error info
     */
    componentDidCatch(errorMsg, errorInfo) {
        console.error(errorMsg, errorInfo);
        let json = { error: errorMsg, componentStack: errorInfo };
        logUI("MBHWeb.UI.MainErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(errorMsg), JSON.stringify(errorInfo));
    }

    //Hard Refresh with kill switch, Soft Refresh based on version number
    handleAppRefresh() {
        console.log("AppRefresh");
        if (typeof window !== 'undefined') window.store.dispatch({ type: types.GET_APP_UPDATE });
    }

    render() {
        const {
            isLoggedIn,
            hasMyChart,
            hasHealthPlan,
            hasPharmacy,
            isHome,
            isPharmacy
        } = this.props;

        return (
            <MainErrorBoundary>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <BrowserRouter>
                            <AppRoutes isHome={isHome} isPharmacy={isPharmacy} isServerSide={false} />
                        </BrowserRouter>
                    </PersistGate>
                </Provider>
            </MainErrorBoundary>
        );
    }
}


export default App;